import $ from "jquery";
import {getFormData} from "../functions/getFormData";
import { translate } from "../../views/main";
import { Api } from "../api/Api";
import IMask from "imask";

window.api = new Api();


export function setOrderCreateFormListener() {
  const createOrderForm = $("#orderCreateForm");

  createOrderForm.submit(function (e) {
    
    e.preventDefault();
    content.removeAllInputErrors();

    const formData = getFormData("#orderCreateForm");
    const anotherman = formData.anotherman === "1";

    const cart = JSON.parse(localStorage.getItem("cart"));
    const dishes = cart.map(c => ({ uuid: c.id, quantity: c.count }))

    const currentCityData = JSON.parse(localStorage.getItem("currentCity"));
    const city = currentCityData.uuid && currentCityData.uuid;
    console.log(formData);

    let pricesSum = cart.reduce((acc, cur) => {
      const totalPriceForDish = Number(cur.price) * Number(cur.count);
      return acc + totalPriceForDish;
    }, 0);

    const basePayload = {
      paymentMethod: formData.paymentmethod,
      comment: formData.comment,
      bonuses: formData.bonuses,
      deliverytime: formData.deliverytimes,
      changefrom: formData.changefrom,
      guestcount: formData.guestcount,
      deliveryprice: (Number(pricesSum) >= Number(formData.freefrom)) ? 0 : Number(formData.deliveryPrice),
      city,
      dishes,
    };
    console.log(basePayload);

    const addressSelect = document.querySelector("#addressesSelect");
    const guestNameInput = document.querySelector("#checkout_guestname");
    const guestPhoneInput = document.querySelector("#checkout_guestphone");
    const bonusBalanceInput = document.querySelector("#checkoutBonusNumberInput");
    const userBonusBalance = bonusBalanceInput.getAttribute("data-bonuses-balance");
    const changefromInput = document.querySelector("#checkout_changefrom");


    if (anotherman && !(formData.guestphone)) {
      content.setInputError(guestPhoneInput);
      return;
    }

    if (anotherman && !(formData.guestname)) {
      content.setInputError(guestNameInput);
      return;
    }

    if (formData.pickup !== "1" && formData.addressId == "undefined") {
      content.setInputError(addressSelect);
      return;
    }

    if(formData.addressId === ''){
      content.setInputError(addressSelect);
      return;
    }

    const totalPrice = cart.reduce((acc, cur) => {
      const totalPriceForDish = Number(cur.price) * Number(cur.count);
      return acc + totalPriceForDish;
    }, 0);

    let percent = DataHelper.store.bonuses.paymentpercent || '0.00'
    let mayPay = totalPrice * +(percent.toString().split('.')[0]) / 100

    if (basePayload.bonuses > mayPay  || basePayload.bonuses > parseFloat(userBonusBalance)) {
      content.setInputError(bonusBalanceInput);
      return;
    }
    
    if(basePayload.paymentmethod === '3a66eede-d7cb-403a-90b5-d2b7e9a141a7' && Number(basePayload.changefrom) < (Number(totalPrice) + Number(basePayload.deliveryprice) - (basePayload.bonuses || 0))){
      console.log(basePayload.changefrom, totalPrice, basePayload.deliveryprice, basePayload.bonuses, totalPrice + Number(basePayload.deliveryprice) - (basePayload.bonuses || 0));
      content.setInputError(changefromInput);
      return;
    }

    // console.log('formData', formData)

    const orderForAnothermanPayload = {
      ...basePayload,
      anotherman: true,
      address: formData.addressId,
      pickup: false,
      guestname: formData.guestname,
      guestphone: formData.guestphone,
    }

    const deliveryOrderForCurrentUserPayload = {
      ...basePayload,
      address: formData.addressId,
      pickup: false,
    };

    const pickupOrderForCurrentUserPayload = {
      ...basePayload,
      pickup: true,
      restaurant: formData.restaurant
    }


    const orderForCurrentUserPayload =
      formData.pickup === "1"
        ? pickupOrderForCurrentUserPayload
        : deliveryOrderForCurrentUserPayload


    const order =
      formData.anotherman === "1"
        ? orderForAnothermanPayload
        : orderForCurrentUserPayload;

    $('#submitButton').prop("disabled", true);
    api.createOrder(order).then(({ data }) => {
      console.log(order);
      if (data.message === "OK") {
       
        console.log(data)
        let orderId = data.order_uuid
        if($('input[type=radio][name=paymentmethod]')[2]?.checked){
          api.onlinePayment(data.order_uuid).then(({data})=>{
            console.log(data)
            document.querySelector('body').innerHTML += `<a id='hiddenLink' href="${data.link}" style='display: none' target='_blank'></a>`
            document.querySelector('#hiddenLink').click()
            document.querySelector('#hiddenLink').remove()
            document.querySelector('#submitButton')
            let interval 
            interval = setInterval(() => api.getPaymentStatus(orderId).then(({data})=>{
              console.log('СТАТУС' ,data)
              if(data.orderStatus == 'APPROVED'){
                clearInterval(interval)
                $(".popup").fadeOut();
                console.log('Условие прошло тут 555')
                localStorage.removeItem("cart");
                $("#success-order-modal").fadeIn();
        
                $("body").css({ overflow: "hidden" });
          
                $('#submitButton').prop("disabled", true);
                $('#submitButton').html(translate("order_sent"));
                localStorage.removeItem("cart");
              }else if(data.orderStatus == 'ON-LOCK' || data.orderStatus == 'ON-REFUND' || data.orderStatus == 'PREAUTH-APPROVED'|| data.orderStatus == 'AUTH-APPROVED' || data.orderStatus == 'CREATED'){

              }else{
                clearInterval(interval)
                $(".popup").fadeOut();
                $("#decline-order-modal").fadeIn();
                document.querySelector('#decline_status').innerHTML = translate(`${data.orderStatus}`)
                $("body").css({ overflow: "hidden" });
                $('#submitButton').prop("disabled", false);
                // document.querySelector('#close_decline_btn').addEventListener('click', ()=>{
                //    $("#decline-order-modal").fadeOut()
                // })
              }
            }), 7000)
          })
        }else{
          $(".popup").fadeOut();
          console.log('Условие прошло тут 555')
          localStorage.removeItem("cart");
          $("#success-order-modal").fadeIn();
        
          $("body").css({ overflow: "hidden" });
          
          $('#submitButton').prop("disabled", true);
          $('#submitButton').html(translate("order_sent"));
        }
        
      }
    }).catch((err)=>{
      console.log(err)
      err = translate(err);
      content.setToastMessage(true ,err);
    });
  })

}
